import * as React from 'react';
import { useMemo } from 'react';

import TagWithIcon from 'bundles/product-card/components/TagWithIcon';
import { getAiSkillsTagNameAndIcon, getGenAiTagNameAndIcon } from 'bundles/product-card/utils/getStatusTagNameAndIcons';
import {
  shouldShowAiSkillsBadge,
  shouldShowRecentlyUpdatedGenAiBadge,
} from 'bundles/product-card/utils/recentlyUpdatedBadgeUtils';

export function getGenAiBadges(slug: string | undefined) {
  if (!slug) {
    return { badges: [], names: [] };
  }

  const badges = [];
  const names = [];

  if (shouldShowRecentlyUpdatedGenAiBadge(slug)) {
    const { tagName, translatedTagName, icon } = getGenAiTagNameAndIcon();
    badges.push(<TagWithIcon key={tagName} tagName={translatedTagName} icon={icon} />);
    names.push(tagName);
  }
  if (shouldShowAiSkillsBadge(slug)) {
    const { tagName, translatedTagName, icon } = getAiSkillsTagNameAndIcon();
    badges.push(<TagWithIcon key={tagName} tagName={translatedTagName} icon={icon} />);
    names.push(tagName);
  }

  return { badges, names };
}

export function useGenAiBadges(slug: string | undefined) {
  const result = useMemo(() => {
    return getGenAiBadges(slug);
  }, [slug]);

  return result;
}

export default useGenAiBadges;
